<template>
    <div id="loading"
         class="min-h-screen w-full flex items-center justify-center p-4 text-white"
         style="background: linear-gradient(to bottom, #2972db 0%, #163D75 100%);">

      <div class="w-full max-w-xl">
        <!-- Logo -->
        <div class="flex justify-center mb-4">
          <!-- Garde un span .logo si c'était utilisé ailleurs -->
          <span class="logo hidden"></span>
          <img :src="logoUrl"
               alt="logo fi360"
               class="h-16 w-auto select-none" />
        </div>

        <!-- Titre -->
        <h2 id="title"
            @click="openErrorDetails"
            class="relative text-xl font-bold text-center mb-4">
          {{ txtInit }}
          <span class="pointSynchro1">.</span><span class="pointSynchro2">.</span><span class="pointSynchro3">.</span>
        </h2>

        <!-- Liste des étapes -->
        <div class="relative max-w-xl mx-auto text-sm">
          <ul class="space-y-2">
            <li id="synchro_detenteur"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Téléchargement des détenteurs et installations</span>
              <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
              <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
            </li>

            <li id="synchro_bouteille"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Téléchargement des bouteilles</span>
              <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
              <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
            </li>

            <li id="synchro_profil"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Téléchargement du profil utilisateur</span>
              <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
              <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
            </li>

            <li id="synchro_outils"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Téléchargement des outillages</span>
              <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
              <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
            </li>

            <li id="synchro_distri"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Téléchargement des distributeurs</span>
              <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
              <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
            </li>

            <li id="synchro_fluides"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Téléchargement des fluides</span>
              <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
              <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
            </li>

            <li id="synchro_op_bouteille"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Téléchargement des opérations bouteille</span>
              <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
              <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
            </li>

            <li id="synchro_otags"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Téléchargement des Otags</span>
              <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
              <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
            </li>

            <li id="synchro_divers"
                class="relative flex items-center justify-between rounded-md bg-white/10 px-3 py-2">
              <span>Autres téléchargements</span>
              <div class="flex items-center gap-3">
                <span class="numberDivers text-sm">{{ this.completedSteps }}/{{ this.totalSteps }}</span>
                <span class="loaderSpin inline-block w-5 h-5 border-4 border-black border-t-white rounded-full animate-spin"></span>
                <span class="check-mark hide text-white text-2xl leading-none">&#10004;</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </template>

  <script>
  import RadialProgressBar from 'vue-radial-progress'
  import Initialisation from '../../js/core/Initialisation.js'
  import Offline from '../../js/models/Offline'

  export default {
    data() {
      return {
        completedSteps: 0,
        totalSteps: 17,
        stopColor: "#2171b7",
        startColor: "#a4cdf3",
        txtInit : "Téléchargement en cours",
        errorInfo: "",
        clicked: 0,
        logoUrl: require('@/img/logo-fi360-nomadia-blanc.svg')
      }
    },
    components: {
      RadialProgressBar
    },
    methods: {
      changeStatus(id) {
        let ligne = document.getElementById(id);
        ligne.querySelector('.loaderSpin').classList.add('hide');
        ligne.querySelector('.check-mark').classList.remove('hide');
      },
      openErrorDetails() {
        this.clicked++;
        if(this.errorInfo !== "" && this.clicked === 3) {
          this.clicked = 0;
          swal({
            title: "Une erreur est survenue",
            html: this.errorInfo + '<br> Vous pouvez contacter le support technique à l\'adresse suivante : <a href="mailto:support@mobiledev-pro.fr">support@mobiledev-pro.fr</a>',
            type: "error",
            confirmButtonText: "Fermer"
          });
        }
      },
      loadData() {
        let vue = this;
        const redirectAfterInit = this.$route.query.redirect;
        Offline
          .getList()
          .then(res => {
            let router = this.$router;
            if (res === null || res.length === 0) {
              localforage
                .getItem('api-token')
                .then(key => {
                  let api = new Initialisation(key);

                  const initDetenteurPromise = api.initDetenteursAndInstall().then(function() {
                    vue.changeStatus('synchro_detenteur');
                  });

                  const otherInitializations = [
                    api.initOfflineActions().then(function() { vue.completedSteps += 1; }),
                    api.initBouteilles().then(function(){ vue.changeStatus('synchro_bouteille'); }),
                    api.initProfil().then(function(){ vue.completedSteps += 1; }),
                    api.initUsers().then(function(){ vue.changeStatus('synchro_profil'); }),
                    api.initOutils().then(function(){ vue.completedSteps += 1; }),
                    api.initFournisseurs().then(function(){ vue.changeStatus('synchro_distri'); }),
                    api.initFluides().then(function(){ vue.changeStatus('synchro_fluides'); }),
                    api.initNomsBouteilles().then(function(){ vue.completedSteps += 1; }),
                    api.initAssemblages().then(function () { vue.completedSteps += 1; }),
                    api.initFuites().then(function () { vue.completedSteps += 1; }),
                    api.initPieces().then(function () { vue.completedSteps += 1; }),
                    api.initPhotosFiche().then(function () { vue.completedSteps += 1; }),
                    api.initFibsdds().then(function(){ vue.completedSteps += 1; }),
                    api.initDistributeurs().then(function(){ vue.completedSteps += 1; }),
                    api.initTransporteurs().then(function(){ vue.completedSteps += 1; }),
                    api.initOperations().then(function(){ vue.changeStatus('synchro_op_bouteille'); }),
                    api.initTypesOutil().then(function (){ vue.changeStatus('synchro_outils'); }),
                    api.initTypesOperation().then(function(){ vue.completedSteps += 1; }),
                    api.initScans().then(function(){ vue.completedSteps += 1; }),
                    api.initOtags().then(function(){ vue.changeStatus('synchro_otags'); }),
                    api.initOptions().then(function(){ vue.completedSteps += 1; }),
                    api.initEvents().then(function(){ vue.completedSteps += 1; }),
                    api.initOthersApi().then(function() { vue.completedSteps += 1; }),
                    api.getLastsDetenteurs(),
                    api.requestTD().then(function () {
                        vue.completedSteps += 1;
                    }),
                    api.getInformationBouteille()
                  ];

                  return Promise.all([initDetenteurPromise, ...otherInitializations]).then(
                    () => {
                      setTimeout(function () {
                        router.push(redirectAfterInit || 'home');
                      }, 100)
                    }
                  ).catch(err => {
                    if(typeof err.response != "undefined" && err.response.status === 403) {
                      localforage.removeItem('lastConnexion').then(() => {
                        router.push('login')
                      })
                    } else {
                      vue.completedSteps = 0
                    }

                    if(err) {
                      let vue = this;
                      const pointSynchros = document.querySelectorAll('.pointSynchro1, .pointSynchro2, .pointSynchro3');
                      pointSynchros.forEach(pointSynchro => {
                        pointSynchro.classList.remove('pointSynchro1');
                        pointSynchro.classList.remove('pointSynchro2');
                        pointSynchro.classList.remove('pointSynchro3');
                        vue.txtInit = "Une erreur est survenue"
                        vue.errorInfo = err
                      });
                    }
                  })
                }).catch()
            } else {
              swal(
                'Données non synchronisées',
                "Veuillez synchroniser vos données hors ligne au plus vite.",
                'warning'
              ).then(
                () => router.push(redirectAfterInit || 'home'),
                () => router.push(redirectAfterInit || 'home')
              )
            }
          })
          .catch()
      }
    },
    async mounted() {
      if (window.location.hash === "#/init") {
        window.location = window.location + '#maj';
        let isNew = false;
        if (window.flutter_inappwebview !== undefined) {
          isNew = await window.flutter_inappwebview.callHandler('handlerIsNew');
        }
        window.wantReload();
      } else {
        this.loadData();
      }
    }
  }
  </script>

  <style scoped>
  /* Garde la classe 'hide' car le JS l’utilise explicitement */
  .hide { display: none !important; }

  /* Forcer la couleur blanche des coches sur tous les navigateurs (dont iOS) */
  .check-mark {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important; /* iOS / Safari */
  }

  /* Dots animés – on garde tes classes pour ne rien casser */
  .pointSynchro1, .pointSynchro2, .pointSynchro3 { display: inline-block; }
  .pointSynchro1 { animation: bounce 1s ease-in-out infinite; }
  .pointSynchro2 { animation: bounce 1s ease-in-out 0.33s infinite; }
  .pointSynchro3 { animation: bounce 1s ease-in-out 0.66s infinite; }

  @keyframes bounce {
    0%, 75%, 100% { transform: translateY(0); }
    25% { transform: translateY(-20px); }
  }
  </style>



// WEBPACK FOOTER //
// InitLoading.vue?3a924a2a